// @ts-nocheck
import {
    SETTLEMENT_INFO_DRAWER_PROPS_CHANGED,
    SETTLEMENT_MARKETS_CHANGED,
    SETTLEMENT_MARKETS_CLEARED,
    SETTLEMENT_MARKETS_FILTERS_CHANGED,
    SETTLEMENT_TICKETS_CHANGED,
    SETTLEMENT_TICKETS_CLEARED,
} from '../types';

const initialTicketsState = {
    data: [],
};

const initialMarketsState = {
    data: {},
    isFetching: false,
    selectedMarkets: [],
    selectedSettlementStatus: [],
    selectedTicketType: 0,
    settlementParams: {},
    filters: {
        status: [],
    },
};

const initialState = {
    tickets: initialTicketsState,
    markets: initialMarketsState,

    settlementInfoDrawerProps: {
        isVisible: false,
    },
};

const settlement = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case SETTLEMENT_TICKETS_CHANGED: {
            return {
                ...state,
                tickets: {
                    ...state.tickets,
                    ...payload,
                },
            };
        }
        case SETTLEMENT_TICKETS_CLEARED: {
            return {
                ...state,
                tickets: { ...initialTicketsState },
            };
        }
        case SETTLEMENT_MARKETS_CHANGED: {
            return {
                ...state,
                markets: {
                    ...state.markets,
                    ...payload,
                },
            };
        }
        case SETTLEMENT_MARKETS_CLEARED: {
            return {
                ...state,
                markets: { ...initialMarketsState },
            };
        }
        case SETTLEMENT_MARKETS_FILTERS_CHANGED: {
            return {
                ...state,
                markets: {
                    ...state.markets,
                    filters: {
                        ...state.markets.filters,
                        ...payload,
                    },
                },
            };
        }
        case SETTLEMENT_INFO_DRAWER_PROPS_CHANGED: {
            return {
                ...state,
                settlementInfoDrawerProps: {
                    ...state.settlementInfoDrawerProps,
                    ...payload,
                },
            };
        }
        default:
            return state;
    }
};

export default settlement;
